<template>
  <el-popover
    placement="left"
    v-model="popover_visible"
    width="500"
    trigger="hover">

    <div v-if="popover_visible">

      <!-- <h5>{{contactId}}</h5> -->

      <UserContactDetails
        @close="popover_visible = false"
        :contact-id="contactId"
        class="mb-4" />

    </div>

    <!-- @dblclick="$emit('select', contactId)" -->
    <div
      slot="reference"
      @drop.prevent.stop="onDropItem"
      @dragover="onDragOver"
      @dragleave="onDragLeave"
      @click="onGoToChat"
      :class="{
        'clickable': true,
        'sidebar-contact': true,
        'sidebar-contact--dropzone-active': active_drop_target,
        'sidebar-contact--dropzone': true,
        'sidebar-contact--is-online': contactStatus.isOnline
      }">

      <div class="sidebar-contact__avatar">
        <span
          class="avatar"
          :style="{ backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(contactStatus.profilePic) + '&quot;)' }">
        </span>
      </div>

      <div class="sidebar-contact__text">
        {{contactStatus.displayName}}
        <template v-if="numNewMessages">
          ({{numNewMessages}})
        </template>
      </div>

      <!-- <el-badge :value="numNewMessages" class="sidebar-contact__badge"></el-badge> -->

      <div class="sidebar-contact__online-status"></div>
      <!-- "online status" (if not me) -->
    </div>
  </el-popover>
</template>

<script>
import { mapActions } from 'vuex'
import UserContactDetails from '@/components/Elements/UserContactDetails'
import DropTaskPrompt from '@/components/Mixins/Prompts/DropTaskPrompt'
import throttle from "lodash.throttle";

// TODO: Show selected contact
// TODO: Performance show popover on hover
// TODO: Show user in chat sidebar on click
// xTODO: Drop zone user

export default {
  mixins: [ DropTaskPrompt ],
  props: {
    contactId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      popover_visible: false, // PERFORMANCE: Load popover content when popover is opened
      active_drop_target: false,
      // cancel_drag_leave: true,
    }
  },
  created() {
    /* FIX: Flickering */
    this.active_drop_target_throttled = throttle(v => {
      this.active_drop_target = v;
    }, 100);
  },
  mounted() {
    this.$api.contact_add_if_not_cached( this.contactId );
  },
  computed: {
    contactStatus() {
      return this.$models.userContact.get_contact_by_id( this.contactId ) || {
        displayName: 'loading...'
      }
    },

    myContactInformationAboutOtherUser() {
      return this.$models.userContact.subscribeNode( this.contactId )
    },

    numNewMessages() {
      let num = this.myContactInformationAboutOtherUser.numNewMessages;
      return num === 0 ? null : num;
    },
  },
  methods: {
    ...mapActions('app', [ 'goToChat' ]),

    onGoToChat() { // COPY: UserContactDetails.vue -> onGoToChat
      if ( ![ 'dayplanner',
              'weekplanner',
              'dayplanner-taskpage',
              'weekplanner-taskpage'
        ].includes( this.$route.name ) ) {
        // Navigate to dayplanner if we're somewhere else right now
        this.$router.push('/dayplanner')
      }
      this.goToChat({ contactId: this.contactId })
      this.$emit('close')
    },

    // TODO: Move to mixin
    onDropItem(event, target) {
      let dragData = {};
      try {
        dragData = JSON.parse( event.dataTransfer.getData("text/plain") );
      } catch (e) {
        console.warn("Got invalid drag item", e)
      }

      /*
      console.log("CONTACT: Dropped item on user", dragData);
      console.log("CONTACT: - taskId", dragData.taskId);
      console.log("CONTACT: - listId", dragData.listId);
      console.log("CONTACT: - goalId", dragData.goalId);
      console.log("CONTACT: - memberId", dragData.memberId);
      */

      this.active_drop_target_throttled(false);

      // TODO: Check if item was task, otherwise show not supported message this.$message()
      if ( !dragData.taskId || !dragData.listId || !dragData.goalId || !dragData.memberId ) {
        this.$message({
          type: 'warning',
          showClose: true,
          message: 'Dragging this type is not supported right now.',
        });
        return
      }

      // 1. check if user is part of the goal otherwise show info
      // 2. show prompt and ask NOT for user and message (DropTaskPrompt)
      // 4. this.$api.contact_send_existing_task({ receiverUserId, message, taskId, goalId, commitmentId })

      let onlyCopyAllowed = !this.checkIfContactIsMember( dragData.goalId, this.contactId );
      /*
      if ( !this.checkIfContactIsMember( dragData.goalId, this.contactId ) ) {
        this.$message({
          type: 'error',
          showClose: true,
          message: 'This user is not member of this goal. Please invite user first.',
        });
        return
      }
      */

      // TODO: Update sortidx not necessary!
      // TODO: Check if the file is from the shared commitment, if yes, don't allow copy

      this
        .$task_drop_prompt({ data: dragData, contactId: this.contactId, onlyCopyAllowed })
        .then(({ config, done }) => {

          let payload = {
            receiverUserId: config.receiverUserId, // this.contactId,
            message:        config.message,
            taskId:         dragData.taskId,
            goalId:         dragData.goalId,
            memberId:       dragData.memberId,
            commitmentId:   dragData.listId, // REMOVE
          };

          let send_task = config.copy
            ? this.$api.contact_send_task_copy
            : this.$api.contact_send_existing_task;

          send_task(payload).then(done).catch(err => {
            this.$message.error(err.message)
            done();
          });
        })
    },

    // onDropInstantTask() {
    //   // TODO: Use shared commitment, show button for instant task
    //   // 1. create shared commitment if not existing
    //   this.$api.contact_create_shared_commitment({ contactUserId: this.contactId });
    //   // 2. create task in sahred commitment
    //   // 3. this.$api.contact_send_existing_task({ receiverUserId, message, taskId, goalId, commitmentId })
    // },

    onDragOver(event) {
      /* Workaround to detect if object being dragged is a file */
      if (event.dataTransfer.effectAllowed === "all") {
        this.active_drop_target_throttled(true);
      }

      /* Workaround to detect if "internal" object */
      if (event.dataTransfer.effectAllowed === "move") {
        this.active_drop_target_throttled(true);
        if (event.preventDefault) {
          event.preventDefault(); // Necessary. Allows us to drop.
        }
      }
    },

    onDragLeave(event) {
      this.active_drop_target_throttled(false);
    },

    // TODO: Move to getters
    checkIfSharedGoal( goalId ) {
      // Check if goal is shared goal
      let all_goal_ids = Object.keys( this.$models.goalMeta.getters.all_goals_user );
      return ( goalId && all_goal_ids.includes( goalId ) );
    },

    // TODO: Move to getters
    checkIfContactIsMember( goalId, contactId ) {
      let goal_meta = this.$models.goalMeta.getData( goalId );
      return goal_meta.members
        && contactId in goal_meta.members
        && !goal_meta.members[ contactId ].hasLeft;
    },
  },
  components: {
    UserContactDetails,
  }
}
</script>

<style>
/*
.sidebar-contact .online-status {
  right: unset;
  left: -2px;
}
*/
/*
.sidebar-contact.sidebar-contact--is-online .online-status {
  background: #4CAF50;
}
.sidebar-contact {
  min-height: 60px;
  text-align: center;
  margin: 2px;
  padding: 2px;
}
.sidebar-contact:focus,
.sidebar-contact:active {
  outline: 1px solid white;
}
.sidebar-contact .sidebar-contact__text {
  display: block;
  font-size: 9pt;
  color: white;
}
*/
/*
.sidebar-contact__badge .el-badge__content {
  top: 18px !important;
}
*/

.sidebar-contact--dropzone-active {
  border: 2px dashed #eaeaea !important;
  border-radius: 4px;
  margin: 2px;
  padding: 0;
}
.sidebar-contact--dropzone-active:hover {
  border: 2px dashed #9a9a9a !important;
}
.sidebar-contact--dropzone-active > * {
  /* Hide icons when dropping file. Use opacity trick so height stays the same. */
  opacity: 0 !important;
  /* Fix "blinking" issue */
  pointer-events: none;
}

</style>
